import React, { useEffect, useState } from "react";
import { useHistory, useLocation, withRouter } from "react-router-dom";

const AppBreadcrumb = (props) => {
    const location = useLocation();
    const history = useHistory();

    let pathname = props.routers.filter((router) => {
        return router.path === location.pathname;
    });

    let path, parent, page;

    // console.log('pathname', pathname !== undefined);
    // console.log('props.routers', props.routers);

    if (pathname[0] !== undefined) {
        if (location.pathname === pathname[0].meta.breadcrumb[0].page) {
            path = pathname[0].meta.breadcrumb[0].label;
            parent = pathname[0].meta.breadcrumb[0].parent;
            page = pathname[0].path.replace('/', '')+ " -";
            // console.log('path1', path);
            if (path.indexOf("Dashboard") !== -1 || path.indexOf("DashBoard") !== -1) {
                page = "";
                path = "";
            }
        } else {
            path = props.routers[0].meta.breadcrumb[0].label;
            parent = props.routers[0].meta.breadcrumb[0].parent;
            page = props.routers[0].meta.breadcrumb[0].page.replace('/', '')+ " -";
            // console.log('path2', path);
            if (path.indexOf("Dashboard") !== -1 || path.indexOf("DashBoard") !== -1) {
                page = "";
                path = "";
            }
        }
    }

    return (
        <div className="route-bar">
            <div className="route-bar-breadcrumb">
                <ul>
                    <li>
                        <label style={{ fontSize: '21px', fontWeight: 'bold' }}>{page} {path}</label>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default withRouter(AppBreadcrumb);
